// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conversation-list-item {
  margin-top: 40px;
  border: 3px solid #f3f5f7;
  border-radius: 20px;
  padding: 20px 24px 14px;
  flex-direction: column;
  cursor: pointer;
}
.conversation-list-item .chat-content {
  max-width: 450px;
}
.conversation-list-item h5 {
  font-size: 16px;
  font-weight: 600;
}

.selected {
  flex-direction: column;
  align-items: flex-start;
  background: #E8ECEF;
  border-radius: 20px;
}

.chat-item {
  display: flex;
  align-items: center;
  gap: 10px; /* Adds space between elements */
  padding: 10px;
}

.checkbox-container {
  flex-shrink: 0; /* Prevents collapsing */
}

.name-container {
  flex-grow: 1;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/ChatList/chatlist.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EAEA,eAAA;AAAF;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;AADJ;;AAKA;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA,EAAA,gCAAA;EACA,aAAA;AAFF;;AAKA;EACE,cAAA,EAAA,wBAAA;AAFF;;AAKA;EACE,YAAA;EACA,eAAA;AAFF","sourcesContent":[".conversation-list-item {\n  margin-top: 40px;\n  border: 3px solid #f3f5f7;\n  border-radius: 20px;\n  padding: 20px 24px 14px;\n  flex-direction: column;\n\n  cursor: pointer;\n\n  .chat-content {\n    max-width: 450px;\n  }\n\n  h5 {\n    font-size: 16px;\n    font-weight: 600;\n  }\n}\n\n.selected {\n  flex-direction: column;\n  align-items: flex-start;\n  background: #E8ECEF;\n  border-radius: 20px;\n}\n\n.chat-item {\n  display: flex;\n  align-items: center;\n  gap: 10px; /* Adds space between elements */\n  padding: 10px;\n}\n\n.checkbox-container {\n  flex-shrink: 0; /* Prevents collapsing */\n}\n\n.name-container {\n  flex-grow: 1;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
